<template>
    <v-card elevation="4" :color="color" class="mb-3" :class="{'theme-aja-active': isThemeAja}">
        <v-card-text>
            <v-row no-gutters align="center" class="headline mb-3">
                <v-col cols="12" :md="10">
                    <v-col class="font-weight-bold white--text">
                        <v-icon v-if="isAja" x-large class="white--text mr-3">psychology</v-icon>
                        {{ title }}
                    </v-col>
                </v-col>
            </v-row>

            <v-row dense justify="center" align="center" class="px-2">
                <v-col :style="{'background-color': carousselBackgroundColor, 'border-radius': '6px' }" class="py-4 mb-2 px-4 mx-4" cols="12" :md="12   ">
                    <split-carousel
                        :height="150"
                        :display-amount="columns"
                        :arrow-area-width="0"
                        :interval="2400"
                        :hover-cancel-play="false"
                    >
                        <split-carousel-item v-for="item in slider" :key="item">
                            <v-img justify="center" align="center" :src="item" height="150px" width="150px" contain></v-img>
                        </split-carousel-item>
                    </split-carousel>
                </v-col>
            </v-row>
            <v-row dense align="center" class="px-2">

                <v-col cols="12" md="3">
                    <v-select
                        v-model="search.day_of_week"
                        :items="[
                            {text: 'Lundi', value: [1]},
                            {text: 'Mardi', value: [2]},
                            {text: 'Mercredi', value: [3]},
                            {text: 'Jeudi', value: [4]},
                            {text: 'Vendredi', value: [5]},
                            {text: 'Samedi', value: [6]},
                            {text: 'Dimanche', value: [7]},
                        ]"
                        label="Jour"
                        flat
                        solo
                        clearable
                        hide-details
                        class="mt-2"
                        :class="{'aja-input': isThemeAja}"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                    <v-select
                        v-model="search.workshopHours"
                        :items="allHours"
                        label="Horaires"
                        flat
                        solo
                        clearable
                        hide-details
                        class="mt-2"
                        :class="{'aja-input': isThemeAja}"
                    ></v-select>
                </v-col>
                <v-col v-if="!isOncommence" cols="12" md="3">
                    <v-autocomplete
                        v-model="search.pro_name"
                        :items="professionalsNames"
                        item-text="firstname"
                        item-value="firstname"
                        label="Professionnel.le"
                        flat
                        solo
                        clearable
                        hide-details
                        :disabled="professionalsNamesLoading"
                        :loading="professionalsNamesLoading"
                        no-data-text="Aucun professionnel trouvé"
                        class="mt-2"
                        :class="{'aja-input': isThemeAja}"
                    ></v-autocomplete>
                </v-col>
                <v-col v-if="isOncommence" cols="12" md="3">
                    <v-select
                        v-model="weekFilter"
                        :items="weekFilterOptions"
                        label="Période"
                        flat
                        solo
                        clearable
                        hide-details
                        class="mt-2"
                        :class="{'aja-input': isThemeAja}"
                    ></v-select>
                </v-col>
                <v-col v-if="isOncommence" cols="12" md="3">
                    <v-checkbox
                        v-model="search.has_available_places"
                        hide-details
                        class="mt-2 text-left custom-checkbox"
                        color="black"
                    >
                        <template v-slot:label>
                            <span style="color: black !important;">Uniquement les sessions ayant des places disponibles</span>
                        </template>
                    </v-checkbox>
                </v-col>

                <v-col v-if="!isOncommence" cols="12" md="3">
                    <v-autocomplete
                        v-model="search.sequence"
                        :items="availableSequences"
                        :loading="sequencesLoading"
                        label="Séquence"
                        flat
                        solo
                        clearable
                        hide-details
                        no-data-text="Aucune séquence trouvée"
                        :filter="sequencesFilter"
                        class="mt-2"
                        :class="{'aja-input': isThemeAja}"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                    <v-divider vertical></v-divider>
                </v-col>
                <v-col cols="12" :md="isOncommence ? 12 : 6" class="text-center">
                    <div v-if="loading" class="d-flex justify-center">
                        <span class="loading-dots">
                            <span>.</span><span>.</span><span>.</span>
                        </span>
                    </div>
                    <div v-else class="text-h6 black--text">
                        <template v-if="isOncommence">
                            {{ total }} session{{ total > 1 ? 's' : '' }} trouvée{{ total > 1 ? 's' : '' }}
                        </template>
                        <template v-else>
                            {{ total }} atelier{{ total > 1 ? 's' : '' }} trouvé{{ total > 1 ? 's' : '' }}
                        </template>
                    </div>
                </v-col>
                <v-col v-if="!isOncommence" cols="12" md="3">
                    <v-checkbox
                        v-model="search.has_available_places"
                        label="Seulement les ateliers ayant des places disponibles pour cette séquence"
                        hide-details
                        class="mt-2 text-left custom-checkbox"
                        color="black"
                        :disabled="!search.sequence"
                        style="color: black !important; --v-checkbox-color: black !important; --v-checkbox-border-color: black !important;"
                    >
                        <template v-slot:label>
                            <span style="color: black !important;">Seulement les ateliers ayant des places disponibles pour cette séquence</span>
                        </template>
                    </v-checkbox>
                </v-col>

                <v-col :cols="isOncommence ? 6 : 5"></v-col>
                <v-col cols="2" class="text-center">
                    <v-btn-toggle
                        :value="options.sortDesc"
                        @change="updateSortDesc"
                        group
                        color="black"
                        class="mt-4"
                        style="--v-btn-toggle-color: black !important;"
                    >
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn :value="false" v-on="on" class="black--text" style="color: black !important;">
                                    <v-icon class="black--text" style="color: black !important;">keyboard_arrow_up</v-icon>
                                </v-btn>
                            </template>
                            <span>Croissant</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn :value="true" v-on="on" class="black--text" style="color: black !important;">
                                    <v-icon class="black--text" style="color: black !important;">keyboard_arrow_down</v-icon>
                                </v-btn>
                            </template>
                            <span>Décroissant</span>
                        </v-tooltip>
                    </v-btn-toggle>
                </v-col>
                <v-col v-if="!isOncommence" cols="5">
                    <p class="black--text text-right">Le n° de la séquence n'a pas d'importance, vous pouvez commencer n'importe quand.</p>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import { SplitCarousel, SplitCarouselItem } from 'vue-split-carousel'
import { mapGetters } from 'vuex'

export default {
    name: 'WorkshopsFilter',
    components: {
        SplitCarousel,
        SplitCarouselItem
    },
    props: {
        title: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: 'primary'
        },
        search: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        allDepartments: {
            type: Array,
            default: () => []
        },
        allCities: {
            type: Array,
            default: () => []
        },
        departmentsLoading: {
            type: Boolean,
            default: false
        },
        citiesLoading: {
            type: Boolean,
            default: false
        },
        professionalsNames: {
            type: Array,
            default: () => []
        },
        professionalsNamesLoading: {
            type: Boolean,
            default: false
        },
        slider: {
            type: Array,
            default: () => []
        },
        total: {
            type: Number,
            default: 0
        },
        isAja: {
            type: Boolean,
            default: false
        },
        isOncommence: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            allHours: [
                {text: 'MATIN', value: ["06:00", "11:00"]},
                {text: 'MIDI', value: ["11:00", "13:00"]},
                {text: 'APRES-MIDI', value: ["13:00", "16:30"]},
                {text: 'FIN D\'APRES-MIDI', value: ["16:30", "20:00", "<="]},
            ],
            availableSequences: [],
            sequencesLoading: false
        }
    },
    mounted() {
        this.fetchAvailableSequences()
    },
    computed: {
        ...mapGetters(['isThemeAja']),
        columns() {
            if (this.$vuetify.breakpoint.xl) return 6
            if (this.$vuetify.breakpoint.lg) return 4
            if (this.$vuetify.breakpoint.md) return 3
            return 2
        },
        carousselBackgroundColor() {
            if (this.isThemeAja) {
                return '#1a3a47'
            }
            return this.$vuetify.theme.dark ? '#1E1E1E' : '#ddd'
        },
        weekFilterOptions() {
            return [
                { text: 'Cette semaine', value: 'this_week' },
                { text: 'La semaine prochaine', value: 'next_week' },
                { text: 'Dans deux semaines', value: 'in_two_weeks' },
            ]
        },
        // #F_SEA_33: filtre semaine pour les sessions onCOMMENCE.
        // Mappe la valeur sélectionnée vers search.dates = [start, end] pour utiliser le filtre backend existant.
        weekFilter: {
            get() {
                if (!this.search.dates || !Array.isArray(this.search.dates)) return null
                // Identifie quel preset matche les dates actuelles (ISO YYYY-MM-DD)
                const presets = this.weekDatePresets()
                for (const [key, range] of Object.entries(presets)) {
                    if (range[0] === this.search.dates[0] && range[1] === this.search.dates[1]) {
                        return key
                    }
                }
                return null
            },
            set(value) {
                if (!value) {
                    this.$set(this.search, 'dates', undefined)
                    return
                }
                const presets = this.weekDatePresets()
                this.$set(this.search, 'dates', presets[value])
            }
        }
    },
    emits: ['update:options'],
    methods: {
        weekDatePresets() {
            // Lundi-dimanche ISO. Tuples [start (lundi 00:00), end (dimanche 23:59:59)] pour inclure
            // toute la semaine (le format MySQL whereBetween est inclusif sur les bornes).
            const fmt = (m) => m.format('YYYY-MM-DD HH:mm:ss')
            return {
                this_week: [
                    fmt(this.$moment().startOf('isoWeek')),
                    fmt(this.$moment().endOf('isoWeek')),
                ],
                next_week: [
                    fmt(this.$moment().add(1, 'week').startOf('isoWeek')),
                    fmt(this.$moment().add(1, 'week').endOf('isoWeek')),
                ],
                in_two_weeks: [
                    fmt(this.$moment().add(2, 'week').startOf('isoWeek')),
                    fmt(this.$moment().add(2, 'week').endOf('isoWeek')),
                ],
            }
        },
        updateSortDesc(value) {
            this.$emit('update:options', {
                ...this.options,
                sortDesc: [value]
            })
        },
        citiesFilter(item, queryText, itemText) {
            return item.nom.toLowerCase().indexOf(queryText.toLowerCase()) == 0
        },
        sequencesFilter(item, queryText, itemText) {
            const searchText = queryText.toLowerCase()
            return item.text.toLowerCase().includes(searchText) || 
                   item.value.toString().includes(searchText)
        },
        fetchAvailableSequences() {
            this.sequencesLoading = true
            this.$store.dispatch('workshopsSequencesRequest', { is_aja: this.isAja ? 1 : 0 })
                .then(result => {
                    this.availableSequences = result.map(sequence => ({
                        text: `Séquence ${sequence}`,
                        value: sequence
                    }))
                })
                .catch(err => {
                    this.$store.dispatch('setErrors', "Une erreur est survenue lors de la récupération des séquences")
                })
                .finally(() => {
                    this.sequencesLoading = false
                })
        }
    },
    watch: {
        'search.sequence'(newVal) {
            if (!newVal) {
                this.search.has_available_places = false
            }
        }
    }
}
</script>

<style>
    .custom-checkbox .v-input--selection-controls__input {
        color: black !important;
    }
    .custom-checkbox .v-input--selection-controls__ripple {
        color: black !important;
    }
    .custom-checkbox .v-input--selection-controls__input .v-icon {
        color: black !important;
    }
    .v-btn-toggle .v-btn {
        color: black !important;
    }
    .v-btn-toggle .v-btn .v-icon {
        color: black !important;
    }
</style>

<style scoped>
    .loading-dots span {
        font-size: 2rem;
        font-weight: 900;
        color: black;
        animation: blink 1s infinite;
        opacity: 0.2;
        line-height: 1;
    }
    .loading-dots span:nth-child(2) { animation-delay: 0.2s; }
    .loading-dots span:nth-child(3) { animation-delay: 0.4s; }

    @keyframes blink {
        0%, 100% { opacity: 0.2; }
        50% { opacity: 1; }
    }

</style> 